var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [
        { name: "el-drag-dialog", rawName: "v-el-drag-dialog" },
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.printLoading,
          expression: "printLoading"
        }
      ],
      staticClass: "app-main-inner",
      attrs: {
        id: "app",
        "element-loading-text": _vm.printLoadingText,
        no: "dialog",
        visible: _vm.isShowDialog,
        title: _vm.$t("Template.WinName"),
        width: "600px",
        "close-on-click-modal": false,
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.isShowDialog = $event
        },
        close: _vm.close
      }
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("el-input", {
                ref: "searchInput",
                attrs: {
                  no: "1",
                  clearable: "",
                  placeholder: _vm.$t("Message.pleaseEnterTemplateName")
                },
                on: { input: _vm.handleFilter },
                model: {
                  value: _vm.filterText,
                  callback: function($$v) {
                    _vm.filterText = typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "filterText"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { padding: "0" } },
        [
          _c(
            "el-checkbox",
            {
              attrs: { no: "2" },
              on: {
                change: function() {
                  return _vm.toFilterRows(1)
                }
              },
              model: {
                value: _vm.isEmailModel,
                callback: function($$v) {
                  _vm.isEmailModel = $$v
                },
                expression: "isEmailModel"
              }
            },
            [_vm._v(_vm._s(_vm.$t("Template.EmailTemp")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "3" },
              on: {
                change: function() {
                  return _vm.toFilterRows(1)
                }
              },
              model: {
                value: _vm.isV3Model,
                callback: function($$v) {
                  _vm.isV3Model = $$v
                },
                expression: "isV3Model"
              }
            },
            [_vm._v(_vm._s(_vm.$t("Template.viewV3")))]
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "app-main-inner-row row-grid",
          staticStyle: { padding: "5px 0" }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", height: "350px" },
            attrs: {
              no: "gird",
              "show-side-bar": false,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData,
              "auto-fit-content": false
            },
            on: { gridReady: _vm.onGridReady }
          })
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          !_vm.callByInstruction
            ? _c(
                "el-button",
                {
                  staticStyle: { float: "left" },
                  attrs: {
                    disabled: !_vm.template || _vm.template.engine === 0,
                    no: "Copy",
                    type: "primary"
                  },
                  on: { click: _vm.showCopyDialog }
                },
                [_vm._v(_vm._s(_vm.$t("Template.Copy")))]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.template &&
                    _vm.template.engine === 2 &&
                    _vm.v3MailSend === 1,
                  expression:
                    "template && template.engine === 2 && v3MailSend === 1"
                }
              ],
              staticStyle: { float: "left" },
              attrs: { no: "4", type: "primary" },
              on: { click: _vm.sendMail }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.SendEMail")))]
          ),
          _vm.template && _vm.template.engine === 2
            ? [
                _c(
                  "el-button",
                  {
                    staticStyle: { float: "left" },
                    attrs: { no: "ExportPDF", type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.exportReport("ExportPDF")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("Message.ExportPDF")))]
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: { float: "left" },
                    attrs: { no: "ExportExcel2", type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.exportReport("ExportXLS")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("Message.ExportExcel2")))]
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: { float: "left" },
                    attrs: { no: "ExportWord", type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.exportReport("ExportWORD")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("Message.ExportWord")))]
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: { float: "left" },
                    attrs: { no: "ExportPPT", type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.exportReport("ExportPPT")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("Message.ExportPPT")))]
                )
              ]
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { no: "5", type: "primary" },
              on: {
                click: function($event) {
                  return _vm.toPrint()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
          ),
          _c("el-button", { attrs: { no: "6" }, on: { click: _vm.close } }, [
            _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
          ])
        ],
        2
      ),
      _c(
        "form",
        {
          ref: "form",
          staticStyle: { display: "none" },
          attrs: { action: _vm.url, target: "_blank", method: "post" }
        },
        _vm._l(_vm.formEntries, function(item) {
          return _c("input", {
            key: item[0],
            attrs: { no: "10", name: item[0] },
            domProps: { value: item[1] }
          })
        }),
        0
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "app-main-inner",
          attrs: {
            no: "copyDialog",
            visible: _vm.copyDialog.visible,
            title: _vm.$t("Template.inputTemplateName"),
            width: "400px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.copyDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "70px", "label-position": "left" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Template.TemplateName") } },
                [
                  _c("el-input", {
                    attrs: { no: "7" },
                    model: {
                      value: _vm.copyDialog.name,
                      callback: function($$v) {
                        _vm.$set(_vm.copyDialog, "name", $$v)
                      },
                      expression: "copyDialog.name"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticStyle: { "padding-right": "30px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "8" },
                  on: { click: _vm.save }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "9" },
                  on: {
                    click: function($event) {
                      _vm.copyDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("cargo-template-preview", {
        attrs: {
          no: "cargoTemplatePreview",
          visible: _vm.cargoTemplatePreview.visible,
          template: _vm.cargoTemplatePreview.template || {},
          "fetch-size": _vm.cargoTemplatePreview.fetchSize || 0,
          parameters: _vm.cargoTemplatePreview.parameters || {},
          entity: _vm.cargoTemplatePreview.entity || {},
          context: _vm.context || {},
          "job-uuid-list": _vm.jobUuidList
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cargoTemplatePreview, "visible", $event)
          },
          sendEmailTriggerEvent: _vm.sendEmailTriggerEventHandler,
          printTempFileEvent: _vm.printTempFileEventHandler,
          sopTriggerEvent: _vm.sopTriggerEventHandler,
          returnMainEvent: _vm.returnMainEventHandler
        }
      }),
      _vm.sendEmailDialog.visible
        ? _c("send-email-dialog", {
            attrs: {
              no: "sendEmailDialog",
              visible: _vm.sendEmailDialog.visible,
              "append-to-body": _vm.appendToBody,
              context: _vm.context,
              "push-link": _vm.SystemConstants.SE_BATCH_PRINT,
              job: _vm.finalCtx,
              "job-uuid-list": _vm.jobUuidList,
              "send-email-data": _vm.sendEmailDialog,
              "send-call-back": _vm.sendCallBackEvent,
              source: _vm.source,
              v3mail: _vm.finalData.V3mail
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.sendEmailDialog, "visible", $event)
              },
              sendMailPreview: _vm.toPrint
            }
          })
        : _vm._e(),
      _vm.overLimitDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "app-main-inner",
              attrs: {
                no: "overLimitDialog",
                visible: _vm.overLimitDialog.visible,
                title: _vm.$t("Message.Prompt"),
                width: "400px",
                "close-on-click-modal": false,
                "append-to-body": ""
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.overLimitDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "center",
                    padding: "10px 0px",
                    "font-size": "14px"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.PrintRecordsOverLimitTip")))]
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "exportPdf2", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.exportReport("ExportPDF")
                          _vm.overLimitDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.ExportPDF")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "exportExcel2", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.exportReport("ExportXLS")
                          _vm.overLimitDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.ExportExcel2")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "exportWord2", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.exportReport("ExportWORD")
                          _vm.overLimitDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.ExportWord")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "ExportPPT2", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.exportReport("ExportPPT")
                          _vm.overLimitDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.ExportPPT")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "cancel2" },
                      on: {
                        click: function($event) {
                          _vm.overLimitDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.over100Dialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "app-main-inner",
              attrs: {
                no: "over100Dialog",
                visible: _vm.over100Dialog.visible,
                title: _vm.$t("Message.Prompt"),
                width: "400px",
                "close-on-click-modal": false,
                "append-to-body": "",
                "before-close": _vm.over100Dialog.beforeClose
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.over100Dialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "center",
                    padding: "10px 0px",
                    "font-size": "14px"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.PrintRecordsOver100Tip")))]
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "exportPdf3", type: "primary" },
                      on: { click: _vm.over100Dialog.exportPdf }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.ExportPDF")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "exportExcel3", type: "primary" },
                      on: { click: _vm.over100Dialog.exportExcel }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.ExportExcel2")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "exportWord3", type: "primary" },
                      on: { click: _vm.over100Dialog.exportWord }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.ExportWord")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "ExportPPT3", type: "primary" },
                      on: { click: _vm.over100Dialog.exportPPT }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.ExportPPT")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "continue3" },
                      on: { click: _vm.over100Dialog.continue }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.ContinuePreview")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }